import { css } from 'styled-components';
import theme from './theme';
import media from './media';
const { colors, fontSizes, fonts, titleSizes, bodySizes, padding, eyebrows, hyperlinks } = theme;

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  outline: css`
    outline: 1px solid red;
  `,
  smallButton: css`
    width: fit-content;
    color: ${colors.darkPurple};
    background-color: ${colors.yellow};
    padding: 10px 1.5rem;
    font-size: ${fontSizes.xs};
    font-family: ${fonts.Montserrat};
    font-style: normal;
    font-weight: bold;
    line-height: 1.2;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      path {
        stroke: ${colors.darkPurple};
        fill: ${colors.darkPurple};
      }
    }

    transition: ${theme.transition};
    &:hover,
    &:focus,
    &:active {
      background-color: ${colors.darkPurple} !important;
      color: ${colors.yellow} !important;
      svg {
        path {
          stroke: ${colors.yellow};
          fill: ${colors.yellow};
        }
      }
    }
    &:after {
      display: none !important;
    }
    &:before {
      content: '';
      position: absolute;
      min-height: 40px;
      margin-left: -10px;
      margin-right: -10px;
      width: -webkit-fill-available;
    }
  `,
  underline: css`
    position: relative;
    &:after {
      content: '';
      bottom: 0;
      display: block;
      height: 1px;
      width: 50%;
      background: transparent;
      opacity: 0;
      position: absolute;
      transition: all 0.3s ease-in;
    }
  `,
  hoverUnderline: css`
    &:after {
      width: 100%;
      opacity: 1;
      background: #5215fc;
    }
  `,
  arrowRight: css`
    transform: translate(0px, 0px);
    transition: all 0.3s ease-in;
  `,
  hoverArrowRight: css`
    transform: translate(3px, 0px);
    transition: all 0.3s ease-in;
  `,
  CTAButton: css`
    padding: 1rem 2.5rem;
    background-color: ${colors.lightPurple};
    color: ${colors.yellow};
    font-size: ${fontSizes.xs};
    font-family: ${fonts.Montserrat};
    line-height: 1.22;
    font-style: normal;
    font-weight: bold;
    cursor: pointer;
    transition: ${theme.transition};
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    &:hover,
    &:focus,
    &:active {
      box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
      /* background-color: #4d23d7; */
      color: ${colors.darkPurple};
      background-color: ${colors.yellow};
    }
    &:after {
      display: none !important;
    }
  `,
  defaultText: css`
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 1.2;
    color: ${colors.white};
  `,
  sectionWidth: css`
    max-width: 2000px;
    margin: auto;
    ${media.bigGiant`max-width: 1335px;`};
    ${media.giant`max-width: 1200px;`};
    ${media.bigDesktop`max-width: 1000px;`};
    ${media.desktop`max-width: 900px;`};
    ${media.smallDesktop`padding-left: 20px; padding-right: 20px;`};
  `,

  /**
   * Custom Styles based on the theme
   */

  /****************** paddings **************/
  pd120_88_64_56_48: css`
    padding-top: ${padding.space15}px;
    padding-bottom: ${padding.space15}px;
    ${media.bigGiant`
      padding-top: ${padding.space11}px;
      padding-bottom: ${padding.space11}px;
    `};
    ${media.giant`
      padding-top: ${padding.space8}px;
      padding-bottom: ${padding.space8}px;
    `};
    ${media.tablet`
      padding-top: ${padding.space7}px;
      padding-bottom: ${padding.space7}px;
    `};
    ${media.thone`
      padding-top: ${padding.space6}px;
      padding-bottom: ${padding.space6}px;
    `};
  `,
  pdSection: css`
    padding-top: ${padding.space12}px;
    padding-bottom: ${padding.space12}px;
    ${media.tablet`
      padding-top: ${padding.space8}px;
      padding-bottom: ${padding.space8}px;
    `};
  `,
  pdSection_normal: css`
    padding-top: ${padding.space15}px;
    padding-bottom: ${padding.space15}px;
    ${media.bigGiant`
      padding-top: ${padding.space14}px;
      padding-bottom: ${padding.space14}px;
    `};
    ${media.giant`
      padding-top: ${padding.space11}px;
      padding-bottom: ${padding.space11}px;
    `};
    ${media.tablet`
      padding-top: ${padding.space9}px;
      padding-bottom: ${padding.space9}px;
    `};
    ${media.thone`
      padding-top: ${padding.space7}px;
      padding-bottom: ${padding.space7}px;
    `};
  `,
  pd100: css`
    padding: ${padding.space12}px;
    ${media.bigGiant`padding: ${padding.space10}px;`};
    ${media.giant`padding: ${padding.space8}px;`};
    ${media.thone`padding: ${padding.space3}px;`};
  `,
  pd90: css`
    padding: ${padding.space11}px;
    ${media.bigGiant`padding: ${padding.space7}px;`};
    ${media.giant`padding: ${padding.space5}px;`};
    ${media.tablet`padding: ${padding.space4}px;`};
    ${media.thone`padding: ${padding.space3}px;`};
  `,
  pd60: css`
    padding: ${padding.space8}px;
    ${media.giant`padding: ${padding.space5}px;`};
    ${media.bigDesktop`padding: ${padding.space4}px;`};
    ${media.tablet`padding: ${padding.space3}px;`};
  `,
  pd40: css`
    padding: ${padding.space5}px;
    ${media.giant`padding: ${padding.space4}px;`};
    ${media.phablet`padding: ${padding.space2}px;`};
  `,
  pd30: css`
    padding: ${padding.space4}px;
    ${media.giant`padding: ${padding.space2}px;`};
    ${media.tablet`padding: ${padding.space1}px;`};
  `,
  pd0: css`
    padding: ${padding.space0}px;
  `,
  pt100: css`
    padding-top: ${padding.space12}px;
    ${media.bigGiant`padding-top: ${padding.space10}px;`};
    ${media.giant`padding-top: ${padding.space8}px;`};
    ${media.thone`padding-top: ${padding.space3}px;`};
  `,
  pt90: css`
    padding-top: ${padding.space11}px;
    ${media.bigGiant`padding-top: ${padding.space8}px;`};
    ${media.giant`padding-top: ${padding.space7}px;`};
    ${media.tablet`padding-top: ${padding.space4}px;`};
    ${media.thone`padding-top: ${padding.space6}px;`};
  `,

  pt80: css`
    padding-top: ${padding.space10}px;
    ${media.bigGiant`padding-top: ${padding.space8}px;`};
    ${media.giant`padding-top: ${padding.space7}px;`};
    ${media.tablet`padding-top: ${padding.space6}px;`};
    ${media.thone`padding-top: ${padding.space4}px;`};
  `,

  pt64: css`
    padding-top: ${padding.space8}px;
    ${media.giant`padding-top: ${padding.space5}px;`};
    ${media.tablet`padding-top: ${padding.space3}px;`};
  `,

  pt32: css`
    padding-top: ${padding.space4}px;
    ${media.thone`padding-top: ${padding.space3}px;`};
  `,

  pt30: css`
    padding-top: ${padding.space4}px;
    ${media.giant`padding-top: ${padding.space2}px;`};
    ${media.tablet`padding-top: ${padding.space1}px;`};
  `,

  pt24: css`
    padding-top: ${padding.space3}px;
    ${media.bigGiant`padding-top: ${padding.space2}px;`};
    ${media.giant`padding-top: ${padding.space1}px;`};
  `,

  pt0: css`
    padding-top: ${padding.space0}px;
  `,

  pb120: css`
    padding-bottom: ${padding.space15}px;
    ${media.tablet`padding-bottom: ${padding.space12}px;`};
    ${media.phablet`padding-bottom: ${padding.space8}px;`};
  `,

  pb100: css`
    padding-bottom: ${padding.space12}px;
    ${media.bigGiant`padding-bottom: ${padding.space10}px;`};
    ${media.giant`padding-bottom: ${padding.space8}px;`};
    ${media.thone`padding-bottom: ${padding.space3}px;`};
  `,
  pb90: css`
    padding-bottom: ${padding.space12}px;
    ${media.bigGiant`padding-bottom: ${padding.space5}px;`};
  `,
  pb56: css`
    padding-bottom: ${padding.space7}px;
    ${media.bigGiant`padding-bottom: ${padding.space5}px;`};
    ${media.tablet`padding-bottom: ${padding.space4}px;`};
  `,

  ph150: css`
    padding: ${padding.space20}px 0;
    ${media.tablet`padding: ${padding.space10}px 0;`};
    ${media.phablet`padding: ${padding.space15}px 0;`};
  `,

  ph120: css`
    padding: ${padding.space15}px 0;
    ${media.giant`padding: ${padding.space11}px 0;`};
    ${media.tablet`padding: ${padding.space10}px 0;`};
    ${media.thone`padding: ${padding.space8}px 0;`};
  `,

  'ph120-t': css`
    padding: ${padding.space15}px 0 ${padding.space7}px 0;
    ${media.giant`padding: ${padding.space11}px 0 ${padding.space5}px 0;`};
    ${media.tablet`padding: ${padding.space10}px 0 ${padding.space5}px 0;`};
    ${media.thone`padding: ${padding.space8}px 0 ${padding.space4}px 0;`};
  `,

  'ph120-b': css`
    padding: ${padding.space7}px 0 ${padding.space15}px 0;
    ${media.giant`padding: ${padding.space5}px 0 ${padding.space11}px 0;`};
    ${media.tablet`padding: ${padding.space5}px 0 ${padding.space10}px 0;`};
    ${media.thone`padding: ${padding.space4}px 0 ${padding.space8}px 0;`};
  `,

  ph120_medium: css`
    padding: ${padding.space15}px 0;
    ${media.bigGiant`padding: ${padding.space14}px 0;`};
    ${media.giant`padding: ${padding.space12}px 0;`};
    ${media.desktop`padding: ${padding.space6}px 0;`};
    ${media.tablet`padding: ${padding.space4}px 0;`};
  `,

  ph120_small: css`
    padding: ${padding.space15}px 0;
    ${media.bigGiant`padding: ${padding.space12}px 0;`};
    ${media.giant`padding: ${padding.space8}px 0;`};
    ${media.tablet`padding: ${padding.space6}px 0;`};
  `,

  pdsection120: css`
    padding: ${padding.space15}px 0;
    ${media.tablet`padding: ${padding.space8}px 0;`};
  `,

  ph100: css`
    padding: ${padding.space12}px 0;
    ${media.bigGiant`padding: ${padding.space10}px 0;`};
    ${media.giant`padding: ${padding.space8}px 0;`};
    ${media.bigDesktop`padding: ${padding.space5}px 0;`};
    ${media.thone`padding: ${padding.space2}px 0;`};
  `,

  ph90: css`
    padding: ${padding.space12}px 0;
    ${media.giant`padding: ${padding.space8}px 0;`};
    ${media.desktop`padding: ${padding.space5}px 0;`};
    ${media.thone`padding: ${padding.space12}px 0;`};
  `,

  'ph90-t': css`
    padding: ${padding.space12}px 0 ${padding.space6}px 0;
    ${media.giant`padding: ${padding.space8}px 0 ${padding.space4}px 0;`};
    ${media.desktop`padding: ${padding.space5}px 0 ${padding.space3}px 0;`};
    ${media.thone`padding: ${padding.space12}px 0 ${padding.space6}px 0;`};
  `,

  'ph90-b': css`
    padding: ${padding.space6}px 0 ${padding.space12}px 0;
    ${media.giant`padding: ${padding.space4}px 0 ${padding.space8}px 0;`};
    ${media.desktop`padding: ${padding.space3}px 0 ${padding.space5}px 0;`};
    ${media.thone`padding: ${padding.space6}px 0 ${padding.space12}px 0;`};
  `,

  ph90_small: css`
    padding: ${padding.space12}px 0;
    ${media.giant`padding: ${padding.space7}px 0;`};
    ${media.tablet`padding: ${padding.space4}px 0;`};
  `,

  ph90_pagination: css`
    padding: ${padding.space11}px 0;
    ${media.bigGiant`padding: ${padding.space9}px 0;`};
    ${media.giant`padding: ${padding.space7}px 0;`};
    ${media.thone`padding: ${padding.space6}px 0;`};
  `,

  ph80: css`
    padding: ${padding.space11}px 0;
    ${media.giant`padding: ${padding.space8}px 0;`};
    ${media.desktop`padding: ${padding.space5}px 0;`};
    ${media.thone`padding: ${padding.space12}px 0;`};
  `,

  ph80_small: css`
    padding: ${padding.space10}px 0;
    ${media.giant`padding: ${padding.space5}px 0;`};
    ${media.tablet`padding: ${padding.space3}px 0;`};
  `,

  ph72: css`
    padding: ${padding.space9}px 0;
    ${media.bigGiant`padding: ${padding.space7}px 0;`};
    ${media.giant`padding: ${padding.space5}px 0;`};
    ${media.thone`padding: ${padding.space4}px 0;`};
  `,

  ph60: css`
    padding: ${padding.space8}px 0;
    ${media.giant`padding: ${padding.space5}px 0;`};
    ${media.bigDesktop`padding: ${padding.space4}px 0;`};
    ${media.tablet`padding: ${padding.space3}px 0;`};
  `,

  'ph60-t': css`
    padding: ${padding.space8}px 0 ${padding.space4}px 0;
    ${media.giant`padding: ${padding.space5}px 0 ${padding.space3}px 0;`};
    ${media.bigDesktop`padding: ${padding.space4}px 0 ${padding.space2}px 0;`};
    ${media.tablet`padding: ${padding.space3}px 0 ${padding.space2}px 0;`};
  `,

  'ph60-b': css`
    padding: ${padding.space4}px 0 ${padding.space8}px 0;
    ${media.giant`padding: ${padding.space3}px 0 ${padding.space5}px 0;`};
    ${media.bigDesktop`padding: ${padding.space2}px 0 ${padding.space4}px 0;`};
    ${media.tablet`padding: ${padding.space2}px 0 ${padding.space3}px 0;`};
  `,

  ph56: css`
    padding: ${padding.space7}px 0;
    ${media.bigGiant`padding: ${padding.space5}px 0;`};
    ${media.giant`padding: ${padding.space3}px 0;`};
  `,

  ph30: css`
    padding: ${padding.space4}px 0;
    ${media.giant`padding: ${padding.space2}px 0;`};
    ${media.tablet`padding: ${padding.space1}px 0;`};
  `,

  ph30_large: css`
    padding: ${padding.space4}px 0;
    ${media.giant`padding: ${padding.space3}px 0;`};
    ${media.tablet`padding: ${padding.space2}px 0;`};
  `,

  ph30_medium: css`
    padding: ${padding.space4}px 0;
    ${media.bigGiant`padding: ${padding.space3}px 0;`};
    ${media.giant`padding: ${padding.space2}px 0;`};
  `,

  ph80: css`
    padding: ${padding.space10}px 0;
    ${media.bigGiant`padding: ${padding.space5}px 0;`};
    ${media.tablet`padding: ${padding.space5}px 0;`};
    ${media.phablet`padding: ${padding.space5}px 0;`};
  `,

  ph56: css`
    padding: ${padding.space7}px 0;
    ${media.bigGiant`padding: ${padding.space5}px 0;`};
    ${media.tablet`padding: ${padding.space4}px 0;`};
  `,

  ph32: css`
    padding: ${padding.space4}px 0;
    ${media.tablet`padding: ${padding.space3}px 0;`};
  `,

  pw120: css`
    padding: ${padding.space15}px;
    ${media.giant`padding: 0 ${padding.space11}px;`};
    ${media.tablet`padding: 0 ${padding.space10}px;`};
    ${media.thone`padding: 0 ${padding.space8}px;`};
  `,

  pw90: css`
    padding: 0 ${padding.space12}px;
    ${media.giant`padding: 0 ${padding.space8}px;`};
    ${media.desktop`padding: 0 ${padding.space5}px;`};
    ${media.thone`padding: 0 ${padding.space4}px;`};
  `,

  pw60: css`
    padding: 0 ${padding.space8}px;
    ${media.giant`padding: 0 ${padding.space5}px;`};
    ${media.desktop`padding: 0 ${padding.space4}px;`};
    ${media.thone`padding: 0 ${padding.space3}px;`};
  `,
  pw30: css`
    padding: 0 ${padding.space4}px;
    ${media.giant`padding: 0 ${padding.space2}px;`};
    ${media.thone`padding: 0 ${padding.space1}px;`};
  `,
  pw0: css`
    padding: 0;
  `,

  mt32: css`
    margin-top: ${padding.space4}px;
    ${media.tablet`margin-top: ${padding.space3}px;`};
  `,

  pt40: css`
    padding-top: ${padding.space5}px;
    ${media.bigGiant`padding-top: ${padding.space4}px;`};
    ${media.tablet`padding: ${padding.space3}px 0;`};
  `,

  pt16: css`
    padding-top: ${padding.space2}px;
    ${media.tablet`padding-top: ${padding.space1}px;`};
  `,
  /****************** animation slide module **************/
  pt96: css`
    padding-top: ${padding.space12}px;
    ${media.bigGiant`padding-top: ${padding.space11}px;`};
    ${media.bigDesktop`padding-top: ${padding.space7}px;`};
    ${media.tablet`padding-top: ${padding.space7}px;`};
    ${media.phablet`padding-top: ${padding.space4}px;`};
  `,

  mb32: css`
    margin-bottom: ${padding.space4}px;
    ${media.giant`margin-bottom: ${padding.space3}px;`};
    ${media.tablet`margin-bottom: ${padding.space2}px;`};
  `,

  /****************** title styles **************/

  titlebig_medium: css`
    font-style: ${titleSizes.h1.fontStyle};
    font-weight: ${titleSizes.h1.fontWeight};
    font-size: ${titleSizes.h1.fontSize};
    line-height: ${titleSizes.h1.lineHeight};
    letter-spacing: ${titleSizes.h1.letterSpacing};

    ${media.giant`
      font-style: ${titleSizes.h80.fontStyle};
      font-weight: ${titleSizes.h80.fontWeight};
      font-size: ${titleSizes.h80.fontSize};
      line-height: ${titleSizes.h80.lineHeight};
      letter-spacing: ${titleSizes.h80.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
  `,

  /*********** title big results title ************/
  titlebig_extra: css`
    font-style: ${titleSizes.h1.fontStyle};
    font-weight: ${titleSizes.h1.fontWeight};
    font-size: ${titleSizes.h1.fontSize};
    line-height: ${titleSizes.h1.lineHeight};
    letter-spacing: ${titleSizes.h1.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
    ${media.bigDesktop`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.phone`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  titlebig: css`
    font-style: ${titleSizes.title140.fontStyle};
    font-weight: ${titleSizes.title140.fontWeight};
    font-size: ${titleSizes.title140.fontSize};
    line-height: ${titleSizes.title140.lineHeight};
    letter-spacing: ${titleSizes.title140.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h1.fontStyle};
      font-weight: ${titleSizes.h1.fontWeight};
      font-size: ${titleSizes.h1.fontSize};
      line-height: ${titleSizes.h1.lineHeight};
      letter-spacing: ${titleSizes.h1.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h80.fontStyle};
      font-weight: ${titleSizes.h80.fontWeight};
      font-size: ${titleSizes.h80.fontSize};
      line-height: ${titleSizes.h80.lineHeight};
      letter-spacing: ${titleSizes.h80.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
  `,

  titlesmall: css`
    font-style: ${titleSizes.h2.fontStyle};
    font-weight: ${titleSizes.h2.fontWeight};
    font-size: ${titleSizes.h2.fontSize};
    line-height: ${titleSizes.h2.lineHeight};
    letter-spacing: ${titleSizes.h2.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    ${media.bigDesktop`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
    ${media.phone`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  title80_small: css`
    font-style: ${titleSizes.h80.fontStyle};
    font-weight: ${titleSizes.h80.fontWeight};
    font-size: ${titleSizes.h80.fontSize};
    line-height: ${titleSizes.h80.lineHeight};
    letter-spacing: ${titleSizes.h80.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
    `};
    ${media.desktop`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
    `};
  `,

  /*********** title h1 ************/
  titleh1: css`
    font-style: ${titleSizes.h1.fontStyle};
    font-weight: ${titleSizes.h1.fontWeight};
    font-size: ${titleSizes.h1.fontSize};
    line-height: ${titleSizes.h1.lineHeight};

    ${media.bigDesktop`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
    `};

    ${media.tablet`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
    `};

    ${media.phablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
    `};
    ${media.phone`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
    `};
  `,

  /*********** title h80 ************/
  titleh80: css`
    font-style: ${titleSizes.h80.fontStyle};
    font-weight: ${titleSizes.h80.fontWeight};
    font-size: ${titleSizes.h80.fontSize};
    line-height: ${titleSizes.h80.lineHeight};

    ${media.bigGiant`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
    `};

    ${media.giant`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
    `};

    ${media.tablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
    `};
  `,

  /*********** Title h2 66px************/
  header66: css`
    font-style: ${titleSizes.h2.fontStyle};
    font-weight: ${titleSizes.h2.fontWeight};
    font-size: ${titleSizes.h2.fontSize};
    line-height: ${titleSizes.h2.lineHeight};
    letter-spacing: ${titleSizes.h2.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
  `,

  /*********** Title h2 66px************/
  title50: css`
    font-style: ${titleSizes.h3.fontStyle};
    font-weight: ${titleSizes.h3.fontWeight};
    font-size: ${titleSizes.h3.fontSize};
    line-height: ${titleSizes.h3.lineHeight};
    letter-spacing: ${titleSizes.h3.letterSpacing};
    ${media.giant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
  `,

  title50_default: css`
    font-style: ${titleSizes.h3.fontStyle};
    font-weight: ${titleSizes.h3.fontWeight};
    font-size: ${titleSizes.h3.fontSize};
    line-height: ${titleSizes.h3.lineHeight};
    letter-spacing: ${titleSizes.h3.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
    ${media.phablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `};
  `,
  /*********** Title h4 ************/
  titleh4: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `}
    ${media.phablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  /*********** Title 42 ************/
  titleh42: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `}
    ${media.tablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `};
  `,

  /*********** Title 42 ************/
  titleh42_24_20_18: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
    ${media.tablet`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `};
  `,

  /*********** Title h5 ************/
  titleh5: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
  `,

  /*********** Title 32 ************/
  title32: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}

    ${media.tablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}
  `,

  // From contentful rich text

  /*********** Contentful Title Extension 42 default title of section ************/
  header100: css`
    font-style: ${titleSizes.h1.fontStyle};
    font-weight: ${titleSizes.h1.fontWeight};
    font-size: ${titleSizes.h1.fontSize};
    line-height: ${titleSizes.h1.lineHeight};
    letter-spacing: ${titleSizes.h1.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h80.fontStyle};
      font-weight: ${titleSizes.h80.fontWeight};
      font-size: ${titleSizes.h80.fontSize};
      line-height: ${titleSizes.h80.lineHeight};
      letter-spacing: ${titleSizes.h80.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${titleSizes.h80.fontStyle};
      font-weight: ${titleSizes.h80.fontWeight};
      font-size: ${titleSizes.h80.fontSize};
      line-height: ${titleSizes.h80.lineHeight};
      letter-spacing: ${titleSizes.h80.letterSpacing};
    `};
    ${media.smallDesktop`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};
    ${media.thone`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    @media only screen and (max-width: 520px) {
      font-size: 46px;
    }
    ${media.phablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    @media only screen and (max-width: 460px) {
      font-size: 36px;
    }
    ${media.phone`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
  `,

  header100_small: css`
    font-style: ${titleSizes.h1.fontStyle};
    font-weight: ${titleSizes.h1.fontWeight};
    font-size: ${titleSizes.h1.fontSize};
    line-height: ${titleSizes.h1.lineHeight};
    letter-spacing: ${titleSizes.h1.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h80.fontStyle};
      font-weight: ${titleSizes.h80.fontWeight};
      font-size: ${titleSizes.h80.fontSize};
      line-height: ${titleSizes.h80.lineHeight};
      letter-spacing: ${titleSizes.h80.letterSpacing};
    `};

    ${media.giant`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};

    ${media.bigDesktop`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};
    ${media.thone`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};

    ${media.phablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: 36px;
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};

    @media only screen and (max-width: 425px) {
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    }

    ${media.phone`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  header80: css`
    font-style: ${titleSizes.h80.fontStyle};
    font-weight: ${titleSizes.h80.fontWeight};
    font-size: ${titleSizes.h80.fontSize};
    line-height: ${titleSizes.h80.lineHeight};
    letter-spacing: ${titleSizes.h80.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h2.fontStyle};
      font-weight: ${titleSizes.h2.fontWeight};
      font-size: ${titleSizes.h2.fontSize};
      line-height: ${titleSizes.h2.lineHeight};
      letter-spacing: ${titleSizes.h2.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${titleSizes.h3.fontStyle};
      font-weight: ${titleSizes.h3.fontWeight};
      font-size: ${titleSizes.h3.fontSize};
      line-height: ${titleSizes.h3.lineHeight};
      letter-spacing: ${titleSizes.h3.letterSpacing};
    `};

    ${media.phablet`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
  `,

  header66_42_32_32_32: css`
    font-style: ${titleSizes.h2.fontStyle};
    font-weight: ${titleSizes.h2.fontWeight};
    font-size: ${titleSizes.h2.fontSize};
    line-height: ${titleSizes.h2.lineHeight};
    letter-spacing: ${titleSizes.h2.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};

    ${media.giant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
  `,

  header60: css`
    font-style: ${titleSizes.header60.fontStyle};
    font-weight: ${titleSizes.header60.fontWeight};
    font-size: ${titleSizes.header60.fontSize};
    line-height: ${titleSizes.header60.lineHeight};
    letter-spacing: ${titleSizes.header60.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};

    ${media.giant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};

    ${media.phablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  /*********** Title h3 what we do page************/

  header50_42_32_32_24: css`
    font-style: ${titleSizes.h3.fontStyle};
    font-weight: ${titleSizes.h3.fontWeight};
    font-size: ${titleSizes.h3.fontSize};
    line-height: ${titleSizes.h3.lineHeight};
    letter-spacing: ${titleSizes.h3.letterSpacing};
    ${media.bigGiant`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
  `};
    ${media.giant`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};
  `};
    ${media.phablet`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};
  `};
  `,

  header50: css`    // 50_42_32_32_24
    font-style: ${titleSizes.h3.fontStyle};
    font-weight: ${titleSizes.h3.fontWeight};
    font-size: ${titleSizes.h3.fontSize};
    line-height: ${titleSizes.h3.lineHeight};
    letter-spacing: ${titleSizes.h3.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.giant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  header50_medium: css`
    font-style: ${titleSizes.h3.fontStyle};
    font-weight: ${titleSizes.h3.fontWeight};
    font-size: ${titleSizes.h3.fontSize};
    line-height: ${titleSizes.h3.lineHeight};
    letter-spacing: ${titleSizes.h3.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h4.fontStyle};
      font-weight: ${titleSizes.h4.fontWeight};
      font-size: ${titleSizes.h4.fontSize};
      line-height: ${titleSizes.h4.lineHeight};
      letter-spacing: ${titleSizes.h4.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  header50_small: css`
    font-style: ${titleSizes.h3.fontStyle};
    font-weight: ${titleSizes.h3.fontWeight};
    font-size: ${titleSizes.h3.fontSize};
    line-height: ${titleSizes.h3.lineHeight};
    letter-spacing: ${titleSizes.h3.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `};
    ${media.thone`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  header42: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.giant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `}
    ${media.phablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
  `,

  header42_small: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing}; 
    `};
  `,

  header42_service_offerings_animation: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing}; 
    `};
    ${media.smallDesktop`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing}; 
    `};
    ${media.tablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `};
    ${media.phablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing}; 
    `};
  `,

  header42_ServiceCard: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `}
    ${media.giant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `};
  `,

  header42_topic: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `}
    ${media.giant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing}; 
    `};
  `,

  header42_MemberCard: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing}; 
    `}
    ${media.desktop`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `};
  `,

  header42_ServiceCard: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `}
    ${media.giant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing}; 
    `};
  `,

  header42_42_42_24_24: css`
    font-style: ${titleSizes.h4.fontStyle};
    font-weight: ${titleSizes.h4.fontWeight};
    font-size: ${titleSizes.h4.fontSize};
    line-height: ${titleSizes.h4.lineHeight};
    letter-spacing: ${titleSizes.h4.letterSpacing};

    ${media.tablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
  `,

  header32_24_24_24_20: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}

    ${media.phablet`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
  `,

  header32_32_24_18_18: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};
    ${media.giant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
    ${media.tablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}
  `,

  header32_24_24_18_18: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}

    ${media.tablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}
  `,

  header32_big: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.desktop`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
  `,

  // From contentful rich text
  /*********** Title h5 ************/
  header32_24_24_24_18: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};
    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
    ${media.phablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}
  `,

  header32_impact: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};
    ${media.tablet`
      font-style: ${titleSizes.h5.fontStyle};
      font-weight: ${titleSizes.h5.fontWeight};
      font-size: ${titleSizes.h5.fontSize};
      line-height: ${titleSizes.h5.lineHeight};
      letter-spacing: ${titleSizes.h5.letterSpacing};
    `}
    ${media.thone`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
  `,

  header32_meditation: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}

    ${media.tablet`
      font-style: ${titleSizes.h6.fontStyle};
      font-weight: ${titleSizes.h6.fontWeight};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `}
  `,

  header32: css`
    font-style: ${titleSizes.h5.fontStyle};
    font-weight: ${titleSizes.h5.fontWeight};
    font-size: ${titleSizes.h5.fontSize};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
  `,

  header24: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
  `,

  header24_middle: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}
  `,


header32_24_24_24_24_20: css`
  font-style: ${titleSizes.h5.fontStyle};
  font-weight: ${titleSizes.h5.fontWeight};
  font-size: ${titleSizes.h5.fontSize};
  line-height: ${titleSizes.h5.lineHeight};
  letter-spacing: ${titleSizes.h5.letterSpacing};

  ${media.bigGiant`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};
  `}
  ${media.phablet`
    font-style: ${titleSizes.lg.fontStyle};
    font-weight: ${titleSizes.lg.fontWeight};
    font-size: ${titleSizes.lg.fontSize};
    line-height: ${titleSizes.lg.lineHeight};
    letter-spacing: ${titleSizes.lg.letterSpacing};
  `}
`,

  header24_24_24_24_20: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};
    ${media.phablet`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
    `,


  header24_24_24_24_18: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};
    ${media.phablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}
  `,

  header24_medium: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};

    ${media.giant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
  `,

  eyebrow18: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    letter-spacing: ${titleSizes.h6.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}

    ${media.tablet`
      font-style: ${titleSizes.sm.fontStyle};
      font-weight: ${titleSizes.sm.fontWeight};
      font-size: ${titleSizes.sm.fontSize};
      line-height: ${titleSizes.sm.lineHeight};
      letter-spacing: ${titleSizes.sm.letterSpacing};
    `}
  `,

  /*********** Title h6 ************/
  titleh6: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};
    ${media.tablet`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
    `};
    ${media.phone`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
    `};
  `,

  title_20_20_20_18_14: css`
    font-style: ${titleSizes.lg.fontStyle};
    font-weight: ${titleSizes.lg.fontWeight};
    font-size: ${titleSizes.lg.fontSize};
    line-height: ${titleSizes.lg.lineHeight};
    letter-spacing: ${titleSizes.lg.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: ${titleSizes.lg.lineHeight};
      letter-spacing: ${titleSizes.lg.letterSpacing};
    `}
    ${media.tablet`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `}

  ${media.thone`
    font-style: ${titleSizes.smish.fontStyle};
    font-weight: ${titleSizes.smish.fontWeight};
    font-size: ${titleSizes.smish.fontSize};
    line-height: ${titleSizes.smish.lineHeight};
    letter-spacing: ${titleSizes.smish.letterSpacing};
  `};
  `,

  /*********** Title lg ************/
  titlelg: css`
    font-style: ${titleSizes.lg.fontStyle};
    font-weight: ${titleSizes.lg.fontWeight};
    font-size: ${titleSizes.lg.fontSize};
    line-height: ${titleSizes.lg.lineHeight};

    ${media.bigDesktop`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
    `};
    ${media.tablet`
      font-style: ${titleSizes.sm.fontStyle};
      font-weight: ${titleSizes.sm.fontWeight};
      font-size: ${titleSizes.sm.fontSize};
      line-height: ${titleSizes.sm.lineHeight};
    `};
    ${media.phone`
      font-style: ${bodySizes.xxxs.fontStyle};
      font-weight: ${bodySizes.xxxs.fontWeight};
      font-size: ${bodySizes.xxxs.fontSize};
      line-height: ${bodySizes.xxxs.lineHeight};
    `};
  `,

  /*********** Title md ************/
  titlemd: css`
    font-style: ${titleSizes.md.fontStyle};
    font-weight: ${titleSizes.md.fontWeight};
    font-size: ${titleSizes.md.fontSize};
    line-height: ${titleSizes.md.lineHeight};

    ${media.bigDesktop`
      font-style: ${titleSizes.md.fontStyle};
      font-weight: ${titleSizes.md.fontWeight};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
    `};
    ${media.tablet`
      font-style: ${titleSizes.sm.fontStyle};
      font-weight: ${titleSizes.sm.fontWeight};
      font-size: ${titleSizes.sm.fontSize};
      line-height: ${titleSizes.sm.lineHeight};
    `};
  `,

  /****************** Text styles **************/
  /****************** SemiBold Text styles **************/
  subtitle45: css`
    font-style: ${eyebrows.semibold45.fontStyle};
    font-weight: ${eyebrows.semibold45.fontWeight};
    font-size: ${eyebrows.semibold45.fontSize};
    line-height: ${eyebrows.semibold45.lineHeight};
    letter-spacing: ${eyebrows.semibold45.letterSpacing};
    ${media.bigGiant`
     font-style: ${eyebrows.semibold40.fontStyle};
     font-weight: ${eyebrows.semibold40.fontWeight};
     font-size: ${eyebrows.semibold40.fontSize};
     line-height: ${eyebrows.semibold40.lineHeight};
     letter-spacing: ${eyebrows.semibold40.letterSpacing};
   `};
    ${media.giant`
     font-style: ${eyebrows.semibold32.fontStyle};
     font-weight: ${eyebrows.semibold32.fontWeight};
     font-size: ${eyebrows.semibold32.fontSize};
     line-height: ${eyebrows.semibold32.lineHeight};
     letter-spacing: ${eyebrows.semibold32.letterSpacing};
   `};
    ${media.thone`
     font-style: ${eyebrows.semibold24.fontStyle};
     font-weight: ${eyebrows.semibold24.fontWeight};
     font-size: ${eyebrows.semibold24.fontSize};
     line-height: ${eyebrows.semibold24.lineHeight};
     letter-spacing: ${eyebrows.semibold24.letterSpacing};
   `};
  `,

  testimonial45: css`
    font-style: ${eyebrows.semibold45.fontStyle};
    font-weight: ${eyebrows.semibold45.fontWeight};
    font-size: ${eyebrows.semibold45.fontSize};
    line-height: ${eyebrows.semibold45.lineHeight};
    letter-spacing: ${eyebrows.semibold45.letterSpacing};
    ${media.bigGiant`
     font-style: ${eyebrows.semibold40.fontStyle};
     font-weight: ${eyebrows.semibold40.fontWeight};
     font-size: ${eyebrows.semibold40.fontSize};
     line-height: ${eyebrows.semibold40.lineHeight};
     letter-spacing: ${eyebrows.semibold40.letterSpacing};
   `};
    ${media.tablet`
     font-style: ${eyebrows.semibold24.fontStyle};
     font-weight: ${eyebrows.semibold24.fontWeight};
     font-size: ${eyebrows.semibold24.fontSize};
     line-height: ${eyebrows.semibold24.lineHeight};
     letter-spacing: ${eyebrows.semibold24.letterSpacing};
   `};
  `,

  semibold40_32_24_24_20: css`
    font-style: ${eyebrows.semibold40.fontStyle};
    font-weight: ${eyebrows.semibold40.fontWeight};
    font-size: ${eyebrows.semibold40.fontSize};
    line-height: ${eyebrows.semibold40.lineHeight};
    letter-spacing: ${eyebrows.semibold40.letterSpacing};
    ${media.bigGiant`
    font-style: ${eyebrows.semibold32.fontStyle};
    font-weight: ${eyebrows.semibold32.fontWeight};
    font-size: ${eyebrows.semibold32.fontSize};
    line-height: ${eyebrows.semibold32.lineHeight};
    letter-spacing: ${eyebrows.semibold32.letterSpacing};
    `};
    ${media.giant`
      font-style: ${eyebrows.semibold24.fontStyle};
      font-weight: ${eyebrows.semibold24.fontWeight};
      font-size: ${eyebrows.semibold24.fontSize};
      line-height: ${eyebrows.semibold24.lineHeight};
      letter-spacing: ${eyebrows.semibold24.letterSpacing};
      `};
    ${media.phablet`
      font-size: ${eyebrows.semibold20.fontSize};
      font-style: ${eyebrows.semibold20.fontStyle};
      font-weight: ${eyebrows.semibold20.fontWeight};
      line-height: ${eyebrows.semibold20.lineHeight};
      letter-spacing: ${eyebrows.semibold20.letterSpacing};
    `};
  `,

  testimonial32: css`
    font-weight: 700;
    font-size: ${titleSizes.h5.fontSize};
    font-style: ${titleSizes.h5.fontStyle};
    line-height: ${titleSizes.h5.lineHeight};
    letter-spacing: ${titleSizes.h5.letterSpacing};

    ${media.bigGiant`
      font-style: ${titleSizes.h6.fontStyle};
      font-size: ${titleSizes.h6.fontSize};
      line-height: ${titleSizes.h6.lineHeight};
      letter-spacing: ${titleSizes.h6.letterSpacing};
    `};

    ${media.giant`
      font-style: ${titleSizes.md.fontStyle};
      font-size: ${titleSizes.md.fontSize};
      line-height: ${titleSizes.md.lineHeight};
      letter-spacing: ${titleSizes.md.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${titleSizes.sm.fontStyle};
      font-size: ${titleSizes.sm.fontSize};
      line-height: ${titleSizes.sm.lineHeight};
      letter-spacing: ${titleSizes.sm.letterSpacing};
    `};

    ${media.phablet`
      font-size: ${eyebrows.semibold14.fontSize};
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};
  `,

  subtitle32: css`
    font-size: ${eyebrows.semibold32.fontSize};
    font-style: ${eyebrows.semibold32.fontStyle};
    line-height: ${eyebrows.semibold32.lineHeight};
    font-weight: ${eyebrows.semibold32.fontWeight};
    letter-spacing: ${eyebrows.semibold32.letterSpacing};

    ${media.desktop`
      font-size: ${eyebrows.semibold18.fontSize};
      font-style: ${eyebrows.semibold18.fontStyle};
      font-weight: ${eyebrows.semibold18.fontWeight};
      line-height: ${eyebrows.semibold18.lineHeight};
      letter-spacing: ${eyebrows.semibold18.letterSpacing};
    `};
  `,

  subtitle32_default: css`
    font-size: ${eyebrows.semibold32.fontSize};
    font-style: ${eyebrows.semibold32.fontStyle};
    line-height: ${eyebrows.semibold32.lineHeight};
    font-weight: ${eyebrows.semibold32.fontWeight};
    letter-spacing: ${eyebrows.semibold32.letterSpacing};

    ${media.bigGiant`
      font-size: ${eyebrows.semibold24.fontSize};
      font-style: ${eyebrows.semibold24.fontStyle};
      font-weight: ${eyebrows.semibold24.fontWeight};
      line-height: ${eyebrows.semibold24.lineHeight};
      letter-spacing: ${eyebrows.semibold24.letterSpacing};
    `};

    ${media.giant`
      font-size: ${eyebrows.semibold20.fontSize};
      font-style: ${eyebrows.semibold20.fontStyle};
      font-weight: ${eyebrows.semibold20.fontWeight};
      line-height: ${eyebrows.semibold20.lineHeight};
      letter-spacing: ${eyebrows.semibold20.letterSpacing};
    `};
    ${media.tablet`
      font-size: ${eyebrows.semibold18.fontSize};
      font-style: ${eyebrows.semibold18.fontStyle};
      font-weight: ${eyebrows.semibold18.fontWeight};
      line-height: ${eyebrows.semibold18.lineHeight};
      letter-spacing: ${eyebrows.semibold18.letterSpacing};
    `};

    ${media.phablet`
      font-size: ${eyebrows.semibold16.fontSize};
      font-style: ${eyebrows.semibold16.fontStyle};
      font-weight: ${eyebrows.semibold16.fontWeight};
      line-height: ${eyebrows.semibold16.lineHeight};
      letter-spacing: ${eyebrows.semibold16.letterSpacing};
    `};
  `,

  subtitle32_medium: css`
    font-size: ${eyebrows.semibold32.fontSize};
    font-style: ${eyebrows.semibold32.fontStyle};
    line-height: ${eyebrows.semibold32.lineHeight};
    font-weight: ${eyebrows.semibold32.fontWeight};
    letter-spacing: ${eyebrows.semibold32.letterSpacing};

    ${media.bigGiant`
      font-size: ${eyebrows.semibold24.fontSize};
      font-style: ${eyebrows.semibold24.fontStyle};
      font-weight: ${eyebrows.semibold24.fontWeight};
      line-height: ${eyebrows.semibold24.lineHeight};
      letter-spacing: ${eyebrows.semibold24.letterSpacing};
    `};

    ${media.desktop`
      font-size: ${eyebrows.semibold20.fontSize};
      font-style: ${eyebrows.semibold20.fontStyle};
      font-weight: ${eyebrows.semibold20.fontWeight};
      line-height: ${eyebrows.semibold20.lineHeight};
      letter-spacing: ${eyebrows.semibold20.letterSpacing};
    `};

    ${media.tablet`
      font-size: ${eyebrows.semibold16.fontSize};
      font-style: ${eyebrows.semibold16.fontStyle};
      font-weight: ${eyebrows.semibold16.fontWeight};
      line-height: ${eyebrows.semibold16.lineHeight};
      letter-spacing: ${eyebrows.semibold16.letterSpacing};
    `};
  `,

  subtitle32_small: css`
    font-size: ${eyebrows.semibold32.fontSize};
    font-style: ${eyebrows.semibold32.fontStyle};
    line-height: ${eyebrows.semibold32.lineHeight};
    font-weight: ${eyebrows.semibold32.fontWeight};
    letter-spacing: ${eyebrows.semibold32.letterSpacing};

    ${media.bigGiant`
      font-size: ${eyebrows.semibold20.fontSize};
      font-style: ${eyebrows.semibold20.fontStyle};
      font-weight: ${eyebrows.semibold20.fontWeight};
      line-height: ${eyebrows.semibold20.lineHeight};
      letter-spacing: ${eyebrows.semibold20.letterSpacing};
    `};

    ${media.tablet`
      font-size: ${eyebrows.semibold14.fontSize};
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};

    ${media.thone`
      font-size: ${eyebrows.semibold12.fontSize};
      font-style: ${eyebrows.semibold12.fontStyle};
      font-weight: ${eyebrows.semibold12.fontWeight};
      line-height: ${eyebrows.semibold12.lineHeight};
      letter-spacing: ${eyebrows.semibold12.letterSpacing};
    `};
  `,

  subtitle24: css`
    font-size: ${eyebrows.semibold24.fontSize};
    font-style: ${eyebrows.semibold24.fontStyle};
    line-height: ${eyebrows.semibold24.lineHeight};
    font-weight: ${eyebrows.semibold24.fontWeight};
    letter-spacing: ${eyebrows.semibold24.letterSpacing};

    ${media.bigGiant`
      font-size: ${eyebrows.semibold20.fontSize};
      font-style: ${eyebrows.semibold20.fontStyle};
      font-weight: ${eyebrows.semibold20.fontWeight};
      line-height: ${eyebrows.semibold20.lineHeight};
      letter-spacing: ${eyebrows.semibold20.letterSpacing};
    `};

    ${media.giant`
      font-size: ${eyebrows.semibold18.fontSize};
      font-style: ${eyebrows.semibold18.fontStyle};
      font-weight: ${eyebrows.semibold18.fontWeight};
      line-height: ${eyebrows.semibold18.lineHeight};
      letter-spacing: ${eyebrows.semibold18.letterSpacing};
    `};

    ${media.tablet`
      font-size: ${eyebrows.semibold16.fontSize};
      font-style: ${eyebrows.semibold16.fontStyle};
      font-weight: ${eyebrows.semibold16.fontWeight};
      line-height: ${eyebrows.semibold16.lineHeight};
      letter-spacing: ${eyebrows.semibold16.letterSpacing};
    `};

    ${media.phablet`
      font-size: ${eyebrows.semibold14.fontSize};
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};
  `,

  subtitle24_14_12: css`
    font-size: ${eyebrows.semibold24.fontSize};
    font-style: ${eyebrows.semibold24.fontStyle};
    line-height: ${eyebrows.semibold24.lineHeight};
    font-weight: ${eyebrows.semibold24.fontWeight};
    letter-spacing: ${eyebrows.semibold24.letterSpacing};

    ${media.bigGiant`
    font-size: ${eyebrows.semibold14.fontSize};
    font-style: ${eyebrows.semibold14.fontStyle};
    font-weight: ${eyebrows.semibold14.fontWeight};
    line-height: ${eyebrows.semibold14.lineHeight};
    letter-spacing: ${eyebrows.semibold14.letterSpacing};
  `};

    ${media.tablet`
    font-size: ${eyebrows.semibold12.fontSize};
    font-style: ${eyebrows.semibold12.fontStyle};
    font-weight: ${eyebrows.semibold12.fontWeight};
    line-height: ${eyebrows.semibold12.lineHeight};
    letter-spacing: ${eyebrows.semibold12.letterSpacing};
  `};
  `,
  subtitle24_medium: css`
    font-size: ${eyebrows.semibold24.fontSize};
    font-style: ${eyebrows.semibold24.fontStyle};
    line-height: ${eyebrows.semibold24.lineHeight};
    font-weight: ${eyebrows.semibold24.fontWeight};
    letter-spacing: ${eyebrows.semibold24.letterSpacing};

    ${media.bigGiant`
      font-size: ${eyebrows.semibold20.fontSize};
      font-style: ${eyebrows.semibold20.fontStyle};
      font-weight: ${eyebrows.semibold20.fontWeight};
      line-height: ${eyebrows.semibold20.lineHeight};
      letter-spacing: ${eyebrows.semibold20.letterSpacing};
    `};
  `,

  subtitle20: css`
    font-size: ${eyebrows.semibold20.fontSize};
    font-style: ${eyebrows.semibold20.fontStyle};
    line-height: ${eyebrows.semibold20.lineHeight};
    font-weight: ${eyebrows.semibold20.fontWeight};
    letter-spacing: ${eyebrows.semibold20.letterSpacing};

    ${media.giant`
      font-size: ${eyebrows.semibold18.fontSize};
      font-style: ${eyebrows.semibold18.fontStyle};
      font-weight: ${eyebrows.semibold18.fontWeight};
      line-height: ${eyebrows.semibold18.lineHeight};
      letter-spacing: ${eyebrows.semibold18.letterSpacing};
    `};

    ${media.desktop`
      font-size: ${eyebrows.semibold16.fontSize};
      font-style: ${eyebrows.semibold16.fontStyle};
      font-weight: ${eyebrows.semibold16.fontWeight};
      line-height: ${eyebrows.semibold16.lineHeight};
      letter-spacing: ${eyebrows.semibold16.letterSpacing};
    `};

    ${media.tablet`
      font-size: ${eyebrows.semibold14.fontSize};
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};
  `,

  subtitle20_small: css`
    font-size: ${bodySizes.sm.fontSize};
    font-style: ${bodySizes.sm.fontStyle};
    line-height: ${bodySizes.sm.lineHeight};
    font-weight: ${bodySizes.sm.fontWeight};
    letter-spacing: ${bodySizes.sm.letterSpacing};

    ${media.giant`
      font-size: ${bodySizes.xs_thin.fontSize};
      font-style: ${bodySizes.xs_thin.fontStyle};
      font-weight: ${bodySizes.xs_thin.fontWeight};
      line-height: ${bodySizes.xs_thin.lineHeight};
      letter-spacing: ${bodySizes.xs_thin.letterSpacing};
    `};
  `,

  //
  /****************** Text text56 mission **************/
  text56_large: css`
    font-style: ${bodySizes.text56.fontStyle};
    font-weight: ${bodySizes.text56.fontWeight};
    font-size: ${bodySizes.text56.fontSize};
    line-height: ${bodySizes.text56.lineHeight};
    letter-spacing: ${bodySizes.text56.letterSpacing};

    ${media.bigGiant`
     font-style: ${bodySizes.xxl.fontStyle};
     font-weight: ${bodySizes.xxl.fontWeight};
     font-size: ${bodySizes.xxl.fontSize};
     line-height: ${bodySizes.xxl.lineHeight};
     letter-spacing: ${bodySizes.xxl.letterSpacing};
   `};

    ${media.giant`
     font-style: ${bodySizes.xl.fontStyle};
     font-weight: ${bodySizes.xl.fontWeight};
     font-size: ${bodySizes.xl.fontSize};
     line-height: ${bodySizes.xl.lineHeight};
     letter-spacing: ${bodySizes.xl.letterSpacing};
   `};

    ${media.desktop`
     font-style: ${bodySizes.sm.fontStyle};
     font-weight: ${bodySizes.sm.fontWeight};
     font-size: ${bodySizes.sm.fontSize};
     line-height: ${bodySizes.sm.lineHeight};
     letter-spacing: ${bodySizes.sm.letterSpacing};
   `};

    ${media.tablet`
     font-style: ${bodySizes.md.fontStyle};
     font-weight: ${bodySizes.md.fontWeight};
     font-size: ${bodySizes.md.fontSize};
     line-height: ${bodySizes.md.lineHeight};
   `};
  `,

  text56: css`
    font-style: ${bodySizes.text56.fontStyle};
    font-weight: ${bodySizes.text56.fontWeight};
    font-size: ${bodySizes.text56.fontSize};
    line-height: ${bodySizes.text56.lineHeight};
    letter-spacing: ${bodySizes.text56.letterSpacing};

    ${media.bigGiant`
     font-style: ${bodySizes.xl.fontStyle};
     font-weight: ${bodySizes.xl.fontWeight};
     font-size: ${bodySizes.xl.fontSize};
     line-height: ${bodySizes.xl.lineHeight};
     letter-spacing: ${bodySizes.xl.letterSpacing};
   `};
    ${media.tablet`
     font-style: ${bodySizes.md.fontStyle};
     font-weight: ${bodySizes.md.fontWeight};
     font-size: ${bodySizes.md.fontSize};
     line-height: ${bodySizes.md.lineHeight};
   `};
    ${media.phone`
     font-style: ${bodySizes.md.fontStyle};
     font-weight: ${bodySizes.md.fontWeight};
     font-size: ${bodySizes.md.fontSize};
     line-height: ${bodySizes.md.lineHeight};
   `};
  `,

  text56_48_36_24_20: css`
    font-style: ${bodySizes.text56.fontStyle};
    font-weight: ${bodySizes.text56.fontWeight};
    font-size: ${bodySizes.text56.fontSize};
    line-height: ${bodySizes.text56.lineHeight};
    letter-spacing: ${bodySizes.text56.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.xxl.fontStyle};
      font-weight: ${bodySizes.xxl.fontWeight};
      font-size: ${bodySizes.xxl.fontSize};
      line-height: ${bodySizes.xxl.lineHeight};
      letter-spacing: ${bodySizes.xxl.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.xl.fontStyle};
      font-weight: ${bodySizes.xl.fontWeight};
      font-size: ${bodySizes.xl.fontSize};
      line-height: ${bodySizes.xl.lineHeight};
      letter-spacing: ${bodySizes.xl.letterSpacing};
    `};
    ${media.tablet`
    font-style: ${bodySizes.md.fontStyle};
    font-size: ${bodySizes.md.fontSize};
    font-weight: ${bodySizes.md.fontWeight};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-size: ${bodySizes.sm.fontSize};
      font-weight: ${bodySizes.sm.fontWeight};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
      `};
  `,

  /****************** Text 48 **************/
  textxxl: css`
    // text48_32_32_24_20
    font-style: ${bodySizes.xxl.fontStyle};
    font-weight: ${bodySizes.xxl.fontWeight};
    font-size: ${bodySizes.xxl.fontSize};
    line-height: ${bodySizes.xxl.lineHeight};
    letter-spacing: ${bodySizes.xxl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.lg.fontStyle};
      font-weight: ${bodySizes.lg.fontWeight};
      font-size: ${bodySizes.lg.fontSize};
      line-height: ${bodySizes.lg.lineHeight};
      letter-spacing: ${bodySizes.lg.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
  `,

  /****************** Text 48px testimonial with image **************/

  body48: css`
    font-style: ${bodySizes.xxl.fontStyle};
    font-weight: ${bodySizes.xxl.fontWeight};
    font-size: ${bodySizes.xxl.fontSize};
    line-height: ${bodySizes.xxl.lineHeight};
    letter-spacing: ${bodySizes.xxl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
    font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
  `,

  /****************** Text Special testimonial 40px**************/
  textsxxlish: css`
    font-style: ${bodySizes.xxlish.fontStyle};
    font-weight: ${bodySizes.xxlish.fontWeight};
    font-size: ${bodySizes.xxlish.fontSize};
    line-height: ${bodySizes.xxlish.lineHeight};
    letter-spacing: ${bodySizes.xxlish.letterSpacing};
    ${media.tablet`
     font-style: ${bodySizes.md.fontStyle};
     font-size: ${bodySizes.md.fontSize};
     line-height: ${bodySizes.md.lineHeight};
     letter-spacing: ${bodySizes.md.letterSpacing};
   `};
  `,

  /****************** Text XL 36px **************/
  textxl: css`
    // text36_24_24_24_20
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
    `};
    ${media.phone`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
  `,

  /****************** Text XL middle 36px **************/
  text36_36_24_18_16: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text36_32_24_24_20: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.lg.fontStyle};
      font-weight: ${bodySizes.lg.fontWeight};
      font-size: ${bodySizes.lg.fontSize};
      line-height: ${bodySizes.lg.lineHeight};
      letter-spacing: ${bodySizes.lg.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  text36_32_24_20_16: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.lg.fontStyle};
      font-weight: ${bodySizes.lg.fontWeight};
      font-size: ${bodySizes.lg.fontSize};
      line-height: ${bodySizes.lg.lineHeight};
      letter-spacing: ${bodySizes.lg.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  text36_32_24_16_16: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.lg.fontStyle};
      font-weight: ${bodySizes.lg.fontWeight};
      font-size: ${bodySizes.lg.fontSize};
      line-height: ${bodySizes.lg.lineHeight};
      letter-spacing: ${bodySizes.lg.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  text36_transform: css`
    //text36_32_24_20_20
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.lg.fontStyle};
      font-weight: ${bodySizes.lg.fontWeight};
      font-size: ${bodySizes.lg.fontSize};
      line-height: ${bodySizes.lg.lineHeight};
      letter-spacing: ${bodySizes.lg.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
  `,

  text36_medium: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text36_28_20_16_14: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.text28.fontStyle};
      font-weight: ${bodySizes.text28.fontWeight};
      font-size: ${bodySizes.text28.fontSize};
      line-height: ${bodySizes.text28.lineHeight};
      letter-spacing: ${bodySizes.text28.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text36_24_24_24_24: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
  `,

  text36_24_24_24_16: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text36_24_20_20_16: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text32_24_24_24_24: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
  `,

  text32_24_24_24_20: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.thone`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
  `,

  text36_small: css`
    font-style: ${bodySizes.xl.fontStyle};
    font-weight: ${bodySizes.xl.fontWeight};
    font-size: ${bodySizes.xl.fontSize};
    line-height: ${bodySizes.xl.lineHeight};
    letter-spacing: ${bodySizes.xl.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};
    `};
    ${media.thone`
      font-style: ${bodySizes.xxxs.fontStyle};
      font-weight: ${bodySizes.xxxs.fontWeight};
      font-size: ${bodySizes.xxxs.fontSize};
      line-height: ${bodySizes.xxxs.lineHeight};
      letter-spacing: ${bodySizes.xxxs.letterSpacing};
    `};
  `,

  /****************** Text32 **************/
  text32_24_20_20_16: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  textlg: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
  `,

  text32_location: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text lg 32 who we are animation slide**************/
  text32: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.tablet`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,
  text32_medium: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.giant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};

    ${media.thone`
        font-style: ${bodySizes.sm.fontStyle};
        font-weight: ${bodySizes.sm.fontWeight};
        font-size: ${bodySizes.sm.fontSize};
        line-height: ${bodySizes.sm.lineHeight};
        letter-spacing: ${bodySizes.sm.letterSpacing};
      `};
  `,

  text32_location_card: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};

    ${media.giant`
        font-style: ${bodySizes.sm.fontStyle};
        font-weight: ${bodySizes.sm.fontWeight};
        font-size: ${bodySizes.sm.fontSize};
        line-height: ${bodySizes.sm.lineHeight};
        letter-spacing: ${bodySizes.sm.letterSpacing};
      `};
  `,

  text32_20_20_20_20: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
  `,

  text32_small: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text32_24_20_20_16_14: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
    ${media.phone`
      font-style: ${bodySizes.xxs.fontStyle};
      font-weight: ${bodySizes.xxs.fontWeight};
      font-size: ${bodySizes.xxs.fontSize};
      line-height: ${bodySizes.xxs.lineHeight};
      letter-spacing: ${bodySizes.xxs.letterSpacing};
    `};
  `,

  text32_20_20_20_16: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text20_20_20_16_16: css`
    font-style: ${bodySizes.sm.fontStyle};
    font-weight: ${bodySizes.sm.fontWeight};
    font-size: ${bodySizes.sm.fontSize};
    line-height: ${bodySizes.sm.lineHeight};
    letter-spacing: ${bodySizes.sm.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};

    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};

    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text32_video: css`
    font-style: ${bodySizes.lg.fontStyle};
    font-weight: ${bodySizes.lg.fontWeight};
    font-size: ${bodySizes.lg.fontSize};
    line-height: ${bodySizes.lg.lineHeight};
    letter-spacing: ${bodySizes.lg.letterSpacing};

    ${media.tablet`
      font-style: ${bodySizes.md.fontStyle};
      font-weight: ${bodySizes.md.fontWeight};
      font-size: ${bodySizes.md.fontSize};
      line-height: ${bodySizes.md.lineHeight};
      letter-spacing: ${bodySizes.md.letterSpacing};
    `};

    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  text28_20_16_16_16: css`
    font-style: ${bodySizes.text28.fontStyle};
    font-weight: ${bodySizes.text28.fontWeight};
    font-size: ${bodySizes.text28.fontSize};
    line-height: ${bodySizes.text28.lineHeight};
    letter-spacing: ${bodySizes.text28.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};

    ${media.giant`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text md 24**************/
  textmd: css`
    //text24_20_20_20_16
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  text24_20_20_20_16: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  textmd_medium: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
       letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.bigGiant`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text md core value of who we are 24px**************/
  text24_20_20_20_16: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  text24_event: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};
    ${media.giant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
    `};
    ${media.thone`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  text24_medium: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};
    ${media.giant`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
    `};
  `,

  /****************** Text md 24**************/
  text24_18_16_16_16: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};

    `};
    ${media.giant`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text md 24**************/
  text20_service_logo: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};

    ${media.bigGiant`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};

    `};
    ${media.giant`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};

    `};
    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text md 24**************/
  textmd_role: css`
    //text24_24_24_20_20
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};

    ${media.tablet`
      font-style: ${bodySizes.sm.fontStyle};
      font-weight: ${bodySizes.sm.fontWeight};
      font-size: ${bodySizes.sm.fontSize};
      line-height: ${bodySizes.sm.lineHeight};
      letter-spacing: ${bodySizes.sm.letterSpacing};
    `};
  `,

  textmd_hero: css`
    font-style: ${bodySizes.md.fontStyle};
    font-weight: ${bodySizes.md.fontWeight};
    font-size: ${bodySizes.md.fontSize};
    line-height: ${bodySizes.md.lineHeight};
    letter-spacing: ${bodySizes.md.letterSpacing};

    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text sm 20px **************/
  textsm: css`
    //text20_18_16_16_16
    font-style: ${bodySizes.sm.fontStyle};
    font-weight: ${bodySizes.sm.fontWeight};
    font-size: ${bodySizes.sm.fontSize};
    line-height: ${bodySizes.sm.lineHeight};
    letter-spacing: ${bodySizes.sm.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.smish.fontStyle};
      font-weight: ${bodySizes.smish.fontWeight};
      font-size: ${bodySizes.smish.fontSize};
      line-height: ${bodySizes.smish.lineHeight};
      letter-spacing: ${bodySizes.smish.letterSpacing};
    `};
    ${media.giant`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${bodySizes.xs.fontStyle};
      font-weight: ${bodySizes.xs.fontWeight};
      font-size: ${bodySizes.xs.fontSize};
      line-height: ${bodySizes.xs.lineHeight};
      letter-spacing: ${bodySizes.xs.letterSpacing};
    `};
  `,

  /****************** Text xs **************/
  textxs: css`
    // text16
    font-style: ${bodySizes.xs.fontStyle};
    font-weight: ${bodySizes.xs.fontWeight};
    font-size: ${bodySizes.xs.fontSize};
    line-height: ${bodySizes.xs.lineHeight};
    letter-spacing: ${bodySizes.xs.letterSpacing};
  `,

  /****************** Text xxs **************/
  textxxs: css`
    // text16_16_16_16_12
    font-style: ${bodySizes.xs.fontStyle};
    font-weight: ${bodySizes.xs.fontWeight};
    font-size: ${bodySizes.xs.fontSize};
    line-height: ${bodySizes.xs.lineHeight};
    letter-spacing: ${bodySizes.xs.letterSpacing};
    ${media.bigGiant`
      font-style: ${bodySizes.xxxs.fontStyle};
      font-weight: ${bodySizes.xxxs.fontWeight};
      font-size: ${bodySizes.xxxs.fontSize};
      line-height: ${bodySizes.xxxs.lineHeight};
      letter-spacing: ${bodySizes.xxxs.letterSpacing};
    `};
  `,

  /****************** Text xxxs **************/
  textxxxs: css`
    // text12
    font-style: ${bodySizes.xxxs.fontStyle};
    font-weight: ${bodySizes.xxxs.fontWeight};
    font-size: ${bodySizes.xxxs.fontSize};
    line-height: ${bodySizes.xxxs.lineHeight};
    letter-spacing: ${bodySizes.xxxs.letterSpacing};
  `,

  /****************** eyebrow **************/
  /****************** eyebrow 20 **************/
  eyebrow24: css`
    font-style: ${eyebrows.semibold24.fontStyle};
    font-weight: ${eyebrows.semibold24.fontWeight};
    font-size: ${eyebrows.semibold24.fontSize};
    line-height: ${eyebrows.semibold24.lineHeight};
    letter-spacing: ${eyebrows.semibold24.letterSpacing};

    ${media.desktop`
      font-style: ${eyebrows.semibold18.fontStyle};
      font-weight: ${eyebrows.semibold18.fontWeight};
      font-size: ${eyebrows.semibold18.fontSize};
      line-height: ${eyebrows.semibold18.lineHeight};
      letter-spacing: ${eyebrows.semibold18.letterSpacing};
    `};

    ${media.tablet`
      font-style: ${eyebrows.semibold16.fontStyle};
      font-weight: ${eyebrows.semibold16.fontWeight};
      font-size: ${eyebrows.semibold16.fontSize};
      line-height: ${eyebrows.semibold16.lineHeight};
      letter-spacing: ${eyebrows.semibold16.letterSpacing};
    `};
  `,

  eyebrow20_small: css`
    font-style: ${eyebrows.semibold20.fontStyle};
    font-weight: ${eyebrows.semibold20.fontWeight};
    font-size: ${eyebrows.semibold20.fontSize};
    line-height: ${eyebrows.semibold20.lineHeight};
    letter-spacing: ${eyebrows.semibold20.letterSpacing};
    ${media.bigGiant`
      font-style: ${eyebrows.semibold16.fontStyle};
      font-weight: ${eyebrows.semibold16.fontWeight};
      font-size: ${eyebrows.semibold16.fontSize};
      line-height: ${eyebrows.semibold16.lineHeight};
      letter-spacing: ${eyebrows.semibold16.letterSpacing};
    `};
    ${media.giant`
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      font-size: ${eyebrows.semibold14.fontSize};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      font-size: ${eyebrows.semibold14.fontSize};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};
  `,

  eyebrow20: css`
    font-style: ${eyebrows.semibold20.fontStyle};
    font-weight: ${eyebrows.semibold20.fontWeight};
    font-size: ${eyebrows.semibold20.fontSize};
    line-height: ${eyebrows.semibold20.lineHeight};
    letter-spacing: ${eyebrows.semibold20.letterSpacing};
    ${media.phablet`
      font-style: ${eyebrows.semibold14.fontStyle};
      font-weight: ${eyebrows.semibold14.fontWeight};
      font-size: ${eyebrows.semibold14.fontSize};
      line-height: ${eyebrows.semibold14.lineHeight};
      letter-spacing: ${eyebrows.semibold14.letterSpacing};
    `};
  `,
  /****************** hyperlinks **************/
  /****************** hyperlink bold 24 **************/
  hyperlinkbold24: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};

    ${media.bigGiant`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
  `,

  hyperlinkbold24_medium: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};

    ${media.bigGiant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.giant`
      font-style: ${hyperlinks.bold14.fontStyle};
      font-weight: ${hyperlinks.bold14.fontWeight};
      font-size: ${hyperlinks.bold14.fontSize};
      line-height: ${hyperlinks.bold14.lineHeight};
      letter-spacing: ${hyperlinks.bold14.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${hyperlinks.bold14.fontStyle};
      font-weight: ${hyperlinks.bold14.fontWeight};
      font-size: ${hyperlinks.bold14.fontSize};
      line-height: ${hyperlinks.bold14.lineHeight};
      letter-spacing: ${hyperlinks.bold14.letterSpacing};
    `};
  `,

  hyperlinkbold24_small: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};

    ${media.giant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
  `,

  hyperlinkbold24_extra: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};

    ${media.giant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.thone`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
  `,

  hyperlinkbold24_18_18_18_16: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.bigGiant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
  `,

  hyperlinkbold24_pagination: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};

    ${media.thone`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
  `,

  hyperlinkbold24_18_18_16_16: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.bigGiant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
  `,

  hyperlinkbold24_16_16_14: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.bigGiant`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${hyperlinks.bold14.fontStyle};
      font-weight: ${hyperlinks.bold14.fontWeight};
      font-size: ${hyperlinks.bold14.fontSize};
      line-height: ${hyperlinks.bold14.lineHeight};
      letter-spacing: ${hyperlinks.bold14.letterSpacing};
    `};
  `,

  hyperlinkbold24_24_24_18_18: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};

    ${media.tablet`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
  `,

  hyperlinkbold18_14_14_14_14: css`
    font-style: ${hyperlinks.bold18.fontStyle};
    font-weight: ${hyperlinks.bold18.fontWeight};
    font-size: ${hyperlinks.bold18.fontSize};
    line-height: ${hyperlinks.bold18.lineHeight};
    letter-spacing: ${hyperlinks.bold18.letterSpacing};
    ${media.bigGiant`
      font-style: ${hyperlinks.bold14.fontStyle};
      font-weight: ${hyperlinks.bold14.fontWeight};
      font-size: ${hyperlinks.bold14.fontSize};
      line-height: ${hyperlinks.bold14.lineHeight};
      letter-spacing: ${hyperlinks.bold14.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${hyperlinks.bold12.fontStyle};
      font-weight: ${hyperlinks.bold12.fontWeight};
      font-size: ${hyperlinks.bold12.fontSize};
      line-height: ${hyperlinks.bold12.lineHeight};
      letter-spacing: ${hyperlinks.bold12.letterSpacing};
    `};
  `,
  /****************** Link Styles **************/
  /****************** Link Large 24px **************/
  linktextlg: css`
    font-style: ${titleSizes.h6.fontStyle};
    font-weight: ${titleSizes.h6.fontWeight};
    font-size: ${titleSizes.h6.fontSize};
    line-height: ${titleSizes.h6.lineHeight};

    ${media.bigGiant`
      font-style: ${titleSizes.lg.fontStyle};
      font-weight: ${titleSizes.lg.fontWeight};
      font-size: ${titleSizes.lg.fontSize};
      line-height: '150%';
    `};

    ${media.phablet`
      line-height: ${titleSizes.lg.lineHeight};
    `};

    ${media.phone`
      font-size: ${bodySizes.xs.fontSize}; 
      line-height: '178%';
    `};
  `,

  /****************** Link md 18px **************/
  linktextmd: css`
    font-style: ${titleSizes.md.fontStyle};
    font-weight: ${titleSizes.md.fontWeight};
    font-size: ${titleSizes.md.fontSize};
    line-height: ${titleSizes.md.lineHeight};

    ${media.bigGiant`
        font-style: ${titleSizes.sm.fontStyle};
        font-weight: ${titleSizes.sm.fontWeight};
        font-size: ${titleSizes.sm.fontSize};
        line-height: ${titleSizes.sm.lineHeight};
      `};

    ${media.phablet`
    font-size: ${bodySizes.xs.fontSize}; 
        line-height: '178%';
      `};

    ${media.phone`
        font-size: ${bodySizes.xxxs.fontSize}; 
        line-height: '125%';
      `};
  `,

  /****************** Link sm 14px **************/
  linktextsm: css`
    font-style: ${bodySizes.xs.fontStyle};
    font-weight: bold;
    font-size: ${bodySizes.xs.fontSize};
    line-height: '178%';

    ${media.phone`
        font-size: ${bodySizes.xxxs.fontSize}; 
        line-height: '125%';
      `};
  `,

  /****************** Icon size **************/
  iconlg: css`
    width: 85px;
    ${media.bigGiant`width: 65px;`};
    ${media.giant`width: 47px;`};
    ${media.tablet`width: 35px;`};
  `,

  /****************** Button size **************/

  hyperlinksbold24_24_18_18_16: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.giant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing}; 
    `};
  `,

  button24: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.bigGiant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.giant`
      font-style: ${hyperlinks.bold14.fontStyle};
      font-weight: ${hyperlinks.bold14.fontWeight};
      font-size: ${hyperlinks.bold14.fontSize};
      line-height: ${hyperlinks.bold14.lineHeight};
      letter-spacing: ${hyperlinks.bold14.letterSpacing}; 
    `};
    ${media.tablet`
    font-style: ${hyperlinks.bold12.fontStyle};
    font-weight: ${hyperlinks.bold12.fontWeight};
    font-size: ${hyperlinks.bold12.fontSize};
    line-height: ${hyperlinks.bold12.lineHeight};
    letter-spacing: ${hyperlinks.bold12.letterSpacing}; 
  `};
    ${media.phablet`
      font-style: ${hyperlinks.bold24.fontStyle};
      font-weight: ${hyperlinks.bold24.fontWeight};
      font-size: ${hyperlinks.bold24.fontSize};
      line-height: ${hyperlinks.bold24.lineHeight};
      letter-spacing: ${hyperlinks.bold24.letterSpacing}; 
    `};
  `,
  ctabutton24: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.tablet`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.phablet`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing}; 
    `};
  `,

  pagination24: css`
    font-style: ${hyperlinks.bold24.fontStyle};
    font-weight: ${hyperlinks.bold24.fontWeight};
    font-size: ${hyperlinks.bold24.fontSize};
    line-height: ${hyperlinks.bold24.lineHeight};
    letter-spacing: ${hyperlinks.bold24.letterSpacing};
    ${media.giant`
      font-style: ${hyperlinks.bold18.fontStyle};
      font-weight: ${hyperlinks.bold18.fontWeight};
      font-size: ${hyperlinks.bold18.fontSize};
      line-height: ${hyperlinks.bold18.lineHeight};
      letter-spacing: ${hyperlinks.bold18.letterSpacing};
    `};
    ${media.desktop`
      font-style: ${hyperlinks.bold16.fontStyle};
      font-weight: ${hyperlinks.bold16.fontWeight};
      font-size: ${hyperlinks.bold16.fontSize};
      line-height: ${hyperlinks.bold16.lineHeight};
      letter-spacing: ${hyperlinks.bold16.letterSpacing};
    `};
    ${media.tablet`
      font-style: ${hyperlinks.bold14.fontStyle};
      font-weight: ${hyperlinks.bold14.fontWeight};
      font-size: ${hyperlinks.bold14.fontSize};
      line-height: ${hyperlinks.bold14.lineHeight};
      letter-spacing: ${hyperlinks.bold14.letterSpacing};
    `};
  `,
};

export default mixins;
